<template>
	<b-modal ref="modalLocalisation" @hidden="resetModal" @shown="modalShown">
		<template slot="modal-header" slot-scope="{ close }">
			<h2 class="mx-auto my-auto">{{ $t('action.reorganiser') }}</h2>
			<i class="btn btn-link my-auto" @click="close()"><font-awesome-icon :icon="['fal', 'times-circle']" /></i>
		</template>
		<template slot="default">
			<div class="row">
				<draggable class="col-12 list-group" group="colonne" :list="children">
                    <div class="list-group-item  d-flex align-items-center" v-for="el in children" :key="el.intralocation_id" @dragend="orderChildren">
						<font-awesome-icon :icon="['far', 'sort']" class="mr-3" /> {{ el.intralocation_label }}
                    </div>
                </draggable>
			</div>

		</template>

		<template slot="modal-footer" class="justify-content-center">
			<b-button variant="primary" @click="saveReorganize" :disabled="processing">
				<font-awesome-icon v-if="processing" :icon="['fas', 'spinner']" pulse />
				{{ $t('global.enregistrer') }}
			</b-button>
		</template>
	</b-modal>
</template>

<script type="text/javascript">
    import IntraLocation from '@/mixins/IntraLocation.js'	

	export default {
		name: 'ModalReorganizeIntraLocation',
		props: ['intralocation', 'refresh_table', 'parents'],
		mixins: [IntraLocation],
		data () {
			return {
				processing: false,
				children: []
			}
		},

		methods: {
			async init_component() {
				this.children = await this.intralocation.children
			},

			openModal() {
				this.init_component()
				this.$refs.modalLocalisation.show()
			},

			async saveReorganize() {
				this.processing = true
				if (!this.parents){
					await this.saveIntraLocationOrder(this.children)
				} else {
					await this.saveLieuOrder(this.children)
				}
				this.processing = false
				this.resetModal()
				this.$refs.modalLocalisation.hide()
				this.successToast('toast.info_save_succes')
				this.$emit('update:refresh_table', !this.refresh_table)
			},

			resetModal() {
                this.processing = false
            },

            modalShown() {
            	this.init_component()
            },

            orderChildren() {
				for (var key in this.children) {
					this.children[key].intralocation_order = key
				}
				this.children.sort(function(a, b){return a.intralocation_order-b.intralocation_order})
            }
		},

		components: {
			draggable: () => import('vuedraggable')
		}
	}

</script>